export default function (value, fixedNum , hasSymbol) {
  if (Number(value) === 0) return value
  return `${hasSymbol && value > 0 ? '+' : ''}${Math.abs(value) >= 10000 ? (value / 10000).toFixed(fixedNum) : value}万`
}
